import { AfterViewInit, Directive, ElementRef } from '@angular/core';

declare var bootstrap: any;

/*Alter header API response*/

@Directive({ selector: '[headerScripts]' })
export class HeaderScriptsDirective implements AfterViewInit {
  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit(): void {
    // Bridge must be set up BEFORE scripts are re-inserted so portal header
    // scripts can use $.fn.modal during their initialization
    this.bridgeJQueryBootstrap();
    this.reinsertScripts();

    //remove href attribute from anchor tags causing route change on account modal open
    document
      .querySelectorAll('a.account-sel-change')
      .forEach((el: HTMLAnchorElement) => {
        el.removeAttribute('href');
        el.style.cursor = 'pointer';
      });

    // Initialize BS5 dropdowns for portal header elements that use legacy data-toggle attributes
    this.initBootstrap5Components();
  }

  /**
   * Bridge Bootstrap 5 native API to jQuery so legacy $.fn.modal() calls
   * from the portal header scripts continue to work.
   */
  private bridgeJQueryBootstrap(): void {
    const $ = (globalThis as any).jQuery;
    if (!$ || $.fn.modal) { return; }

    // Register $.fn.modal for legacy portal header scripts
    $.fn.modal = function (action?: string | object) {
      return this.each(function () {
        if (bootstrap === undefined || !bootstrap.Modal) { return; }
        const modalInstance = bootstrap.Modal.getOrCreateInstance(this);
        if (typeof action === 'string') {
          if (action === 'show') {
            modalInstance.show();
          } else if (action === 'hide') {
            modalInstance.hide();
          } else if (action === 'toggle') {
            modalInstance.toggle();
          } else if (action === 'handleUpdate') {
            modalInstance.handleUpdate();
          }
        }
        // If action is an object or undefined, the modal is just being initialized
      });
    };
  }

  /**
   * Portal header HTML from API uses Bootstrap 3 data-toggle attributes.
   * BS5 only recognizes data-bs-toggle, so we manually initialize dropdowns.
   */
  private initBootstrap5Components(): void {
    setTimeout(() => {
      const el = this.elementRef.nativeElement;

      // Convert legacy data-toggle="dropdown" to data-bs-toggle for BS5
      el.querySelectorAll('[data-toggle="dropdown"]').forEach((toggle: HTMLElement) => {
        toggle.dataset.bsToggle = 'dropdown';
        if (bootstrap !== undefined && bootstrap.Dropdown) {
          bootstrap.Dropdown.getOrCreateInstance(toggle);
        }
      });

      // Convert legacy data-toggle="collapse" to data-bs-toggle for BS5
      el.querySelectorAll('[data-toggle="collapse"]').forEach((toggle: HTMLElement) => {
        const target = toggle.dataset.target || toggle.getAttribute('href');
        if (target) {
          toggle.dataset.bsToggle = 'collapse';
          toggle.dataset.bsTarget = target;
        }
        if (bootstrap !== undefined && bootstrap.Collapse) {
          bootstrap.Collapse.getOrCreateInstance(toggle, { toggle: false });
        }
      });

      // Convert legacy data-toggle="modal" to data-bs-toggle for BS5
      el.querySelectorAll('[data-toggle="modal"]').forEach((toggle: HTMLElement) => {
        const target = toggle.dataset.target;
        if (target) {
          toggle.dataset.bsToggle = 'modal';
          toggle.dataset.bsTarget = target;
        }
      });

      // Convert legacy data-dismiss to data-bs-dismiss for BS5
      el.querySelectorAll('[data-dismiss]').forEach((toggle: HTMLElement) => {
        toggle.dataset.bsDismiss = toggle.dataset.dismiss;
      });
    }, 100);
  }

  /*initiate the iframe*/
  reinsertScripts(): void {
    let iframex: string;
    iframex = ` $(document).ready(function() {
                var messageHandlerIframe = document.getElementById('messageHandler');
                if(messageHandlerIframe) {
                    $('#messageHandler').attr('src', messageHandlerIframe.src);
                    var salesForceChatIframe = document.getElementById('salesForceChatIframe');
                    if(salesForceChatIframe) {
                        salesForceChatIframe.style.display = 'none';
                    }
                }
        });`;

    const scripts = <HTMLScriptElement[]>(
      this.elementRef.nativeElement.getElementsByTagName('script')
    );
    const scriptsInitialLength = scripts.length;
    for (let i = 0; i < scriptsInitialLength; i++) {
      const script = scripts[i];
      const scriptCopy = <HTMLScriptElement>document.createElement('script');
      scriptCopy.type = script.type ? script.type : 'text/javascript';

      if (script.innerHTML) {
        scriptCopy.innerHTML =
          i == 0 ? script.innerHTML.concat(iframex) : script.innerHTML;
      } else if (script.src) {
        scriptCopy.src = script.src;
      }
      scriptCopy.async = false;
      script.parentNode.replaceChild(scriptCopy, script);
    }
  }
}
